export type WithdrawalPanelMode = 'released' | 'hidden' | 'message';

export function normalizeWithdrawalPanelMode(raw?: string | null): WithdrawalPanelMode {
  const m = String(raw || '').toLowerCase().trim();
  if (m === 'hidden') return 'hidden';
  if (m === 'message') return 'message';
  return 'released';
}
